import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';

import { ISitemateAssignedUserWithTaskUrls } from '@site-mate/dashpivot-shared-library';

import { AppHierarchy } from 'app/shared/model/app-hierarchy.enum';

@Component({
  selector: 'cc-template-links-list-modal',
  templateUrl: './template-links-list-modal.component.html',
  styleUrls: [
    '../../../../styles/components/sitemate-form-tables.scss',
    './template-links-list-modal.component.scss',
  ],
})
export class TemplateLinksListModalComponent implements OnInit {
  @Input() assignedUser: ISitemateAssignedUserWithTaskUrls;
  @Input() hierarchy: AppHierarchy;
  @Output() readonly close = new EventEmitter<void>();
  displayFolder = false;

  ngOnInit() {
    this.displayFolder = [AppHierarchy.Organisation, AppHierarchy.Project].includes(this.hierarchy);
  }

  onClose(): void {
    this.close.emit();
  }
}
